import { TApplicationState } from '../../types/redux';

export function getMarkedList(state: TApplicationState) {
  return state.newbuilding.markedList;
}
